export default __webpack_public_path__ + "static/media/recibo-ipgs-logo.62c555d6.png";